module.exports = "pegasus_template/assets/theme3/small/3.jpg";